module.exports = __webpack_public_path__ + "img/face-content.6d446770.svg";